import styled from 'styled-components'
import { backgroundThemes, useCases } from '../../../constants/contentfulStyle.constant'
import ImgUtil from '../../../utils/img.utils'

export const VerticalGrid = styled.div.attrs(props => ({
  className: props.className,
}))`
  ${({ theme }) => {
    const isCentered = theme.props.extraThemes.useCase === useCases.CENTER
    const isDarkTheme = theme.props.extraThemes.isDarkTheme
    const black = theme.webMktPalette.text.primaryBlack
    const white = theme.webMktPalette.text.primaryWhite
    const showBreadcrumbs = theme.props.extraThemes.showBreadcrumbs

    return `
      padding: 32px 24px;
      margin-top: ${showBreadcrumbs && !isCentered ? '32' : '16'}px;
      text-align: ${isCentered ? 'center' : 'auto'};
      max-width: ${isCentered ? '900' : '690'}px;
      
      .text {
        color: ${isDarkTheme ? white : black};
      }

      .FlexibleHero__Logo {
        margin-bottom: 32px;
      }
      
      .FlexibleHero__Eyebrow {
        margin-top: 0;
        margin-bottom: 8px;
        text-transform: uppercase;
      }

      .FlexibleHero__Headline {
        margin-top: 0;
        margin-bottom: 24px;
      }
    
      .FlexibleHero__Subheadline {
        margin-top: 0;
        margin-bottom: 24px;
      }
    
      .FlexibleHero__KeyData {
        margin-top: 0;
        margin-bottom: 32px;
        font-weight: 600;
      }
    
      .FlexibleHero__Buttons {
        margin-bottom: 16px;
        
        .FlexibleHero__Button {
          margin-right: 20px;
        }
      }
    `
  }}
`

export const MainImage = styled.div.attrs(props => ({
  className: props.className,
}))`
  width: 100%;
  display: flex;
  justify-content: center;

  ${({ theme }) => {
    const backgroundUrl = theme.props.extraThemes.backgroundUrl
    const isCentered = theme.props.extraThemes.useCase === useCases.CENTER
    const isSmallKey = theme.props.extraThemes.useCase === useCases.SMALL_KEY
    const showBreadcrumbs = theme.props.extraThemes.showBreadcrumbs
    let background = ''

    background = `
      background-image: url(${ImgUtil.getResizedImageUrl(backgroundUrl, '')});
      background-size: cover;
      border-radius: 1px;
    `
    return isCentered
      ? `
      ${background};
      padding-top: ${showBreadcrumbs ? '40' : '0'}px;
    `
      : `
      padding: ${isSmallKey ? '20px' : '0 20px'};
      padding-top: ${showBreadcrumbs ? '30' : '0'}px;
    `
  }};
`

export const FlexibleHeroContainer = styled.div.attrs((props: any) => ({
  extraThemes: props.extraThemes,
}))`
  ${({ theme, extraThemes }) => {
    theme.props.extraThemes = extraThemes
    const customXSBreakpoint = 590

    const isCentered = theme.props.extraThemes.useCase === useCases.CENTER
    const backgroundUrl = extraThemes.backgroundUrl
    const typography = theme.webMktTypography.typography
    const isSmallKey = theme.props.extraThemes.useCase === useCases.SMALL_KEY
    let backgroundTheme = ''

    switch (extraThemes.backgroundTheme) {
      case backgroundThemes.DARK:
        backgroundTheme = theme.webMktPalette.background.dark
        break
      case backgroundThemes.GREY:
        backgroundTheme = theme.webMktPalette.background.gray
        break
      case backgroundThemes.LIGHT:
        backgroundTheme = theme.webMktPalette.background.white
        break
    }

    let background = ''
    let flexDirection = 'row'

    if (isCentered) {
      flexDirection = 'column-reverse'
    } else {
      background = `
        background-image: url(${ImgUtil.getResizedImageUrl(backgroundUrl, '')});
        background-size: cover;
        background-position: center;
        border-radius: 1px;
      `
    }

    return `
      ${background}
      background-color: ${backgroundTheme};
      position: relative;
      max-width: 1920px;
      margin: auto;

      .FlexibleHero__Wrapper {
        display: flex;
        flex-direction: ${flexDirection};
        justify-content: center;
        align-items: center;
        padding: 0;

        .FlexibleHero__VerticalGrid {
          flex: 7;
        }

        .FlexibleHero__MainImage_Container { 
          flex: 5;
        }
      }

      .FlexibleHero__Breadcrumb {
        position: absolute;
        padding: 24px 0 10px 24px;
      }

      // CSS style applies when screen width is less than sm & md breakpoint
      @media (max-width: ${theme.breakpoints.values.lg}px) {
        .FlexibleHero__Headline {
          font-size: ${typography.heading1.md.fontSize};
          line-height: ${typography.heading1.md.lineHeight};
        }
      
        .FlexibleHero__Subheadline {
          font-size: ${typography.leadXS.lg.fontSize};
          line-height: ${typography.leadXS.lg.lineHeight};
        }
      
        .FlexibleHero__KeyData {
          font-size: ${typography.leadXS.lg.fontSize};
          line-height: ${typography.leadXS.md.lineHeight};
        }
      }

      @media (max-width: ${theme.breakpoints.values.md}px) {
        .FlexibleHero__VerticalGrid {
          padding-left: 16px;
          max-width: ${isCentered ? '650' : '380'}px;

          .FlexibleHero__Eyebrow {
            font-size: ${typography.bodyXS.lg.fontSize};
          }
    
          .FlexibleHero__Headline {
            font-size: ${typography.heading1.sm.fontSize};
            line-height: ${typography.heading1.sm.lineHeight};
          }
        }

        .FlexibleHero__Breadcrumb {
          padding-left: 16px;
        }
      }

      @media (max-width: ${theme.breakpoints.values.sm}px) {
        background-image: none;

        .FlexibleHero__GlobalContainer {
          padding: 0;
          max-width: 770px;
        }
        
        .FlexibleHero__Wrapper {
          flex-direction: column-reverse;
        }
        
        .FlexibleHero__VerticalGrid {
          align-self: start;
          padding: 16px;
          margin-left: ${isCentered ? 0 : 15}%;
          margin-top: ${isCentered ? 0 : 16}px;
        }

        .FlexibleHero__Buttons {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .FlexibleHero__MainImage_Container {
          ${background};
          background-position: ${isCentered ? 'cover' : '60%'};
          padding-left: 0;
          padding-right: 0;

          .FlexibleHero__MainImage {
            width: ${isCentered ? 'auto' : '65%'};
          }
        }

        .FlexibleHero__Breadcrumb {
          padding-top: 16px;
          padding-left: 16px;
        }
      }

      @media (max-width: ${customXSBreakpoint}px) {
        .FlexibleHero__VerticalGrid {
          margin-left: 0;
          align-self: center;
        }

        .FlexibleHero__MainImage_Container {
          padding-top: ${isSmallKey ? '45px' : 'auto'};
        }
      }
    `
  }};
`
